// @ts-nocheck

import gsap from 'gsap'
import { defPath, fetchPath } from '../config/defPath'
import { PopsController } from './popsController'
import { useGeneralConfig } from '../hooks/useGeneralConfig';
import { useSession } from '../hooks/useState';

window.dataLayer = window.dataLayer || [];

export class QuestionsController {
  public questionWrapper: HTMLElement | null
  public questionContent: HTMLElement | null
  public question: HTMLElement | null
  public timeline
  public session: boolean
  public audio: Audio

  constructor() {
    this.questionWrapper = document.querySelector('.ar__questions_overlay')
    this.question = document.querySelector(".ar__questions")
    this.questionContent = document.querySelector(".ar__questions--content")
    this.audio = new Audio()
    this.timeline = gsap.timeline({
      defaults: {
        ease: 'power1.in',
        duration: 0.35
      }
    })
  }

  async questionsAvailable() {
    let questionsAvaible = 0   
    if (typeof(Storage) !== 'undefined') { questionsAvaible  = useSession.getState().user.total_questions }
    return questionsAvaible
    // try {
    //   const res = await fetch(`${fetchPath}/aguila/loyalty/questions`, { method: 'POST' })
    //   const questions = await res.json()
    //   return questions.response.length > 0
    // } catch (error) {
    //   return false
    // }
  }

  async open() {
    if (!this.questionContent) return

    window.avatar.toggleControls(false)

    this.questionContent.innerHTML = await renderTemplateQuestions()

    addSelectFetch()

    this.timeline.to(this.questionWrapper, {
      opacity: 1,
      onStart() {
        this.targets()[0].style.display = 'block'
      }
    }, 0)

    this.timeline.to(this.question, {
      y: 0,
      opacity: 1
    }, 0.25)
  }

  close() {
    this.timeline.to(this.question, {
      y: '20%',
      opacity: 0
    }, 0)
    this.timeline.to(this.questionWrapper, {
      opacity: 0,
      onComplete() {
        this.targets()[0].style.display = 'none'
      }
    }, 0.25)

  }
}

interface QuestionsList {
  id: string,
  coins: string,
  question: string
  options: {
    text: string
  }[]
}

let questionList: QuestionsList[] = []
let questionCurrent: QuestionsList

function random(min: number, max: number) {
  return Math.floor((Math.random() * (max - min + 1)) + min);
}

const renderTemplateQuestions = async (): Promise<string> => {

  let q, questions

  try {
    if (window.drupalSettings && window.drupalSettings.user.uid == 0){
      if (typeof(Storage) !== 'undefined') {
        
        if (sessionStorage.getItem('general-estadio') !== 'undefined') {
            q  = JSON.parse(sessionStorage.getItem('general-estadio')).state.totalq
            questionList  = JSON.parse(sessionStorage.getItem('general-estadio')).state.questions

            if ( q === 0 ) return false

        }
      }
    } else {
      const res = await fetch(`${fetchPath}/aguila/loyalty/questions`, { method: 'POST' })
      const questions = await res.json()
      if ( questions.response.length === 0 )  return false
      questionList = [...questions.response]
    }
    
  } catch (error) {
    console.warn(error.message)
  }

  questionCurrent = questionList[random(0, questionList.length - 1)]
  window.dataLayer.push({
    'event': 'GAEvent',
    'event_category': 'Content',
    'event_action': 'Content',
    'event_label':  'You found a collectable - PassionPoint' ,
    'interaction':'true',
    'component_name': 'Modo_Carrera_Stadium_CollectablesandPP',
    'element_text': `${questionCurrent?.question}`,
  });

  window.soundController && window.soundController.play2('q', questionCurrent.sound)

  return `
    <div class="ar__questions--header">
        <span class="black_30">Contesta y obtén</span>
        <div class="contentSpans">
          <img class="ar__questions--header--icon" src="${defPath}/assets/images/popups/points.png" alt="icono coins" />
          <span class="black_45 yellow">+${questionCurrent?.coins}</span>
        </div>
    </div>
    <div class="ar__questions--box">
      <p class="medium_30">${questionCurrent?.question}</p>
      
      <div class="ar__questions__select">
        <div class="ar__questions__select--field">
          <select id="select_1" data-coins="${questionCurrent?.coins}" data-points="${questionCurrent?.points}" data-idQuestion="${questionCurrent?.id}" required>
            <option value="">Selecciona tu respuesta</option>
            ${options(questionCurrent?.options)}
          </select>				
        </div>
        <button class="ar__btn-submit" disabled></button>
      </div>
    </div>
  `
}

const options = (items: any) => {
  let template = ''
  items.map((item: any) => {
    template += `<option value="${item.text}">${item.text}</option>`
  })
  return template
}

const addSelectFetch = () => {
  
  const btnSubmit = document.querySelector('.ar__btn-submit') as HTMLButtonElement
  const select = document.querySelector('#select_1') as HTMLSelectElement
  select && select.addEventListener('change', () => {
    if ((select.value.length > 0) ) {
      // window.dataLayer.push({
      //   'event': 'GAEvent',
      //   'event_category': 'Form',
      //   'event_action': 'Click',
      //   'event_label': 'Send',
      //   'interaction':'true',
      //   'component_name': `${select.value}`,
      //   'element_text': `${select.value}`,
      // });
      btnSubmit.removeAttribute('disabled')
    } else {
      btnSubmit.setAttribute('disabled', 'true')
    }
  })
  
  btnSubmit && btnSubmit.addEventListener('click', async () => {
    const btnClose = document.querySelector('.ar__questions--close') as HTMLButtonElement
    btnClose.click()

    const body = {
      question: `${questionCurrent.question}`,
      answer: select.value,
      id: select.dataset.idquestion,
      coins: select.dataset.coins,
      points: select.dataset.points
    }

    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Button',
      'event_label': `${questionCurrent.question} - PassionPoint`,
      'interaction':'true',
      'component_name': 'Modo_Carrera_Stadium_CollectablesandPP',
      'element_text': `${select.value}`,
    });

    const popup = new PopsController()
    popup.open('questions', body)

    window.npc.complete()

  })
}

// await new QuestionsController().questionsAvailable() // hay preguntas disponibles ? true (si hay) : false (no hay)